import React from 'react';
import './DataBankCTA.css';
import { Link } from 'react-router-dom';

const DataBankCTA = () => {
  return (
    <section className="databank-cta-section">
      <div className="databank-cta-container">
        <div className="section-header">
          <h2>Data for confident decisions</h2>
          <div className="header-line"></div>
        </div>
        <p className="databank-description">
          Our extensive global commodity trade data and prices coverage across diverse markets provide you with the critical information you need for success. 
          {/* We use Link components for internal navigation */}
          <Link to="/data-bank-download" className="databank-link"> Download</Link>
          <Link to="/data-bank" className="databank-link"> CRISHI data bank</Link>
        </p>
      </div>
    </section>
  );
};

export default DataBankCTA;